//@flow
import React, { Component } from "react";
import AddWishlistToCart from "../add-wishlist-to-cart";

import type { ProductType } from "../types/product";
import type { ProductPurchasability } from "../types/publicpurchasable";

type Props = {
  products: ProductType[],
  isPostCodeAvailable: boolean,
  isLoadingPurchasability: boolean,
  productPurchasabilityMap: Map<number, ProductPurchasability>
};

class ListInfo extends Component<Props> {
  render() {
    return (
      <div className="wishlist-main__list-info">
        <span className="wishlist-main__list-detail">
          Showing {this.props.products.length} products
        </span>
        <div className="wishlist-main__list-options">
          <AddWishlistToCart
            className="btn-with-loader wishlist-main__add-to-cart"
            products={this.props.products}
            isPostCodeAvailable={this.props.isPostCodeAvailable}
            productPurchasabilityMap={this.props.productPurchasabilityMap}
            isLoadingPurchasability={this.props.isLoadingPurchasability}
          />
        </div>
      </div>
    );
  }
}

export default ListInfo;
